import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Nav, ProgressBar, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

export default function PrevisitForm() {
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');

      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-9">

            <div className="d-md-flex align-items-center justify-content-between mb-4">
                <div>
                  <h4 className="main-title mb-0"></h4>
                </div>
                <div className="d-flex gap-2 mt-3 mt-md-0">
                  <Button variant="primary" className="d-flex align-items-center gap-2">
                    <i className="ri-bar-chart-2-line fs-18 lh-1"></i>Book Appointment<span className="d-none d-sm-inline"></span>
                  </Button>
                </div>
      
                  
            </div>
            <Nav className="nav-line mb-4">
                <Nav.Link href="/dashboard/schedule-appointment" >Schedule Appointment</Nav.Link>
                <Nav.Link href="/dashboard/myappointment" >Upcomming Appointments</Nav.Link>
                <Nav.Link href="/dashboard/appointment-history" >Appointment History </Nav.Link>
                <Nav.Link href="/dashboard/previsit-form" className="active">Pre-visit Form </Nav.Link>
            </Nav>
            <div className={"divider divider-start fw-medium mb-3" }>
                <span className="my-10">Pre-visit Form</span>
            </div>

            <div>
              <Row className="g-3 mb-3">
                <Col xs="" md="6">
                  <Form.Label>Name:</Form.Label>
                  <Form.Control type="text" placeholder="Choose name" />
                </Col>
                <Col xs="" md="6">
                  <Form.Label>Email:</Form.Label>
                  <Form.Control type="text" placeholder="Choose email" />
                </Col>
              </Row>

              <Row className="g-3 mb-3">
                <Col xs="" md="6">
                  <Form.Label>Phone Number:</Form.Label>
                  <Form.Control type="text" placeholder="Choose phone number" />
                </Col>
                <Col xs="" md="6">
                  <Form.Label>Date:</Form.Label>
                  <Form.Control type="text" placeholder="Choose date" />
                </Col>
              </Row>

              <Row className="g-3 mb-3">
                <Col xs="" md="6">
                  <Form.Label>Date:</Form.Label>
                  <Form.Control type="text" placeholder="Choose date" />
                </Col>
              </Row>

              <div>
                <Form.Label>Reason For Visit</Form.Label>
                <Form.Control as="textarea" rows="3" placeholder="Write some description (optional)" />
              </div>


               <div className=" gap-2 mt-3">
                <Button variant="primary" className="d-flex align-items-center gap-2">
                  <i className="ri-bar-chart-2-line fs-18 lh-1"></i>Submit<span className="d-none d-sm-inline"></span>
                </Button>
              </div>

            </div>

        <Footer />
      </div>
    </React.Fragment>
  );
}
